import React from 'react';
import { Link } from 'react-router-dom';
import { Plane, Calendar, Hotel, Users, Coffee, BarChart3, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const { cardNumber, logout } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const menuItems = [
    {
      icon: Plane,
      title: language === 'fr' ? 'Vols Exclusifs' : 'Exclusive Flights',
      path: '/member/flights',
      description: language === 'fr' ? 'Consultez et réservez vos vols' : 'View and book your flights'
    },
    {
      icon: Hotel,
      title: language === 'fr' ? 'Séjours' : 'Stays',
      path: '/member/stays',
      description: language === 'fr' ? 'Découvrez nos séjours exclusifs' : 'Discover our exclusive stays'
    },
    {
      icon: Calendar,
      title: language === 'fr' ? 'Events' : 'Events',
      path: '/member/events',
      description: language === 'fr' ? 'Événements VIP programmés' : 'Scheduled VIP events'
    },
    {
      icon: Users,
      title: language === 'fr' ? 'Séminaires' : 'Seminars',
      path: '/member/seminaires',
      description: language === 'fr' ? 'Séminaires privés d\'affaires' : 'Private business seminars'
    },
    {
      icon: Coffee,
      title: language === 'fr' ? 'After-Work' : 'After-Work',
      path: '/member/afterwork',
      description: language === 'fr' ? 'Nos after-works hebdomadaires' : 'Our weekly after-works'
    },
    {
      icon: BarChart3,
      title: language === 'fr' ? 'Mes Réservations' : 'My Bookings',
      path: '/member/bookings',
      description: language === 'fr' ? 'Historique et réservations' : 'History and bookings'
    }
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-secondary)' }}>
      {/* Header */}
      <div style={{
        background: 'var(--bg-primary)',
        borderBottom: '1px solid var(--border-light)',
        padding: '32px 40px'
      }}>
        <div className="container" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          maxWidth: '1400px'
        }}>
          <div>
            <h1 className="hero-medium" style={{ marginBottom: '8px' }}>
              {language === 'fr' ? 'Espace Membre' : 'Member Area'}
            </h1>
            <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
              {language === 'fr' ? 'Carte N°' : 'Card No.'} {cardNumber}
            </p>
          </div>
          <button
            onClick={handleLogout}
            className="btn-secondary"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <LogOut size={16} />
            {language === 'fr' ? 'Déconnexion' : 'Logout'}
          </button>
        </div>
      </div>

      {/* Menu Grid */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '32px'
          }}>
            {menuItems.map((item, index) => {
              const Icon = item.icon;
              return (
                <Link
                  key={index}
                  to={item.path}
                  className="hover-lift"
                  style={{
                    padding: '40px',
                    background: 'var(--bg-primary)',
                    border: '1px solid var(--border-light)',
                    textDecoration: 'none',
                    display: 'block',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <div style={{
                    width: '56px',
                    height: '56px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px',
                    border: '1px solid var(--border-light)',
                    background: 'var(--bg-secondary)'
                  }}>
                    <Icon size={28} color="var(--text-primary)" />
                  </div>
                  <h3 className="heading-2" style={{ marginBottom: '8px', color: 'var(--text-primary)' }}>
                    {item.title}
                  </h3>
                  <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {item.description}
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;